import { cn } from '@/lib/utils';
import { forwardRef } from 'react';

/** Fix table to make header sticky - Shadcn/ui Table has a wrapping div as a parent of table causing issue*/
export const TableComponent = forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(
  ({ className, ...props }, ref) => (
    <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} />
  )
);
TableComponent.displayName = 'TableComponent';
